import * as React from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import { useSelector } from 'react-redux';

const filterOptions = createFilterOptions({
  matchFrom: 'any',
  stringify: (option) => `${option.winthor} ${option.nome}`,
});

export default function ProdutoCod({ value, setValue, inputValue, setInputValue, inputRef }) {
  const { productos } = useSelector((state) => state.product);

  return (
    <div>
      <Autocomplete
        slotProps={{
          popper: {
            modifiers: [
              {
                name: 'zIndex',
                enabled: true,
                phase: 'write',
                fn: ({ state }) => {
                  state.styles.popper.zIndex = '9999';
                },
              },
            ],
          },
        }}
        className="bg-white z-50  rounded-md"
        sx={{ height: 44, border: 'none' }}
        value={value}
        onChange={(event, newValue) => {
          setValue(newValue);
        }}
        inputValue={inputValue}
        onInputChange={(event, newInputValue) => {
          setInputValue(newInputValue);
        }}
        id="controllable-states-demo"
        options={productos}
        getOptionLabel={(option) => option.nome}
        isOptionEqualToValue={(option, value) => option.id === value?.id}
        filterOptions={filterOptions}
        renderInput={(params) => (
          <TextField
            inputRef={inputRef}
            {...params}
            placeholder="Digite o nome ou código..." // Mantém o placeholder
            variant="outlined"
            // Input
            inputProps={{
              ...params.inputProps,
              sx: {
                height: 'auto', // Define a altura do input
                padding: '0', // Ajuste o padding para que o campo não fique com bordas muito grandes
              },
            }}
            sx={{
              '& .MuiOutlinedInput-root': {
                height: 44, // Controla a altura do campo de input
              },
            }}
          />
        )}
        autoComplete="off"
      />
    </div>
  );
}
